import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader } from '@/components/ui/card'
import useTranslator from '@/hooks/translation'

export function TranslationLoadError() {
  const { getTranslation } = useTranslator()

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-background p-4">
      <Card className="flex w-full max-w-md flex-col items-center bg-card-opaque p-8 text-center">
        <CardHeader className="space-y-4 pb-6">
          <div className="mx-auto text-6xl font-bold text-muted-foreground">
            Ops...
          </div>
        </CardHeader>

        <CardContent className="space-y-6">
          <div className="space-y-2">
            <h1 className="text-2xl font-semibold text-foreground">
              {getTranslation('components.reactRouterErrorElement.title')}
            </h1>
            <p className="text-muted-foreground">
              {getTranslation('components.reactRouterErrorElement.description')}
            </p>
          </div>

          <Button variant="fintalk" onClick={() => window.location.reload()}>
            {getTranslation('common.retry')}
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}
